module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containerc"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("An article in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Münchner Merkur")]), _vm._v(" of 22 June 2016 entitled ‘Suddenly our world collapsed’ led me to Lothar Herrmann in Garmisch-Partenkirchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Already at our first meeting he wanted to impress on me how comforted he felt by the thought that the youth of today were able to live in peace.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("They should never have to experience the school of hard knocks which I and so many of my contemporaries had to experience. But let me also point out that those who don’t have any idea about the past or what it entailed will certainly be unable to understand the present. Whilst neither our politicians of today nor our younger generation have themselves experienced war, we can only hope that we can rely on them to safeguard the prosperity which our society is able to enjoy now, and which we’ve fought so hard to achieve after the war. Seeing as I am probably one of the last witnesses of that era, it is yet another reason why I’m so keen to try and preserve the memory of my wartime experiences for posterity.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having been credited as author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("U-188: A German Submariner’s Account of the War at Sea, 1941–1945")]), _vm._v(","), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Preface#rfnch00_1",
      "id": "fnch00_1"
    }
  }, [_vm._v("*")])]), _vm._v(" I decided to follow the same route with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Death March Through Russia")]), _vm._v(" and thus assumed authorship for this book as well. So, whilst this book also appears under my name and is narrated in the first person, the "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("story and memories are those of Lothar Herrmann, as he described them to me in our many meetings. Why did I go down that route? After giving the issue much thought, I remain convinced that this is most certainly the better way of transmitting to our readers the message of how the dictators of all the states involved in that war condemned their young people to misery and death, without a care in the world, ruthlessly and without ever offering any definition of what they considered just or unjust.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Klaus Willmann")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Preface#fnch00_1",
      "id": "rfnch00_1"
    }
  }, [_vm._v("*")])]), _vm._v(" Klaus Willmann/Anton Staller, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("U-188: A German Submariner’s Account of the War at Sea, 1941–1945")]), _vm._v(", Pen & Sword, 2015.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9ba40f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Preface.vue
// module id = 78
// module chunks = 0